import { ApiError } from '@/api/client';

/**
 * Messages des erreurs métier de la diffusion, indexés par le CODE stable de l'API — jamais
 * par son message, qui peut être reformulé côté serveur sans préavis.
 */
const MESSAGES: Record<string, string> = {
  'broadcast.not_found': "Cette diffusion n'existe plus. Rechargez la page.",
  'broadcast.ended': 'Cette diffusion est terminée : elle ne peut plus être modifiée.',
  'broadcast.no_target': 'Sélectionnez au moins un écran.',
  'broadcast.too_many_targets': "Trop d'écrans sélectionnés pour une seule diffusion.",
  'broadcast.format_incompatible':
    "Le format de cette vidéo ne convient pas à l'un des écrans choisis (paysage ou portrait).",
  'broadcast.not_scheduled': "Cette diffusion n'est plus en cours : rechargez la page.",
  'broadcast.not_paused': "Cette diffusion n'est plus en pause : rechargez la page.",
  'screen.not_found': "L'un des écrans choisis n'existe plus. Rechargez la page.",
  'screen.not_ready': "L'un des écrans choisis n'est pas appairé ou est désactivé.",
};

export function describeBroadcastError(error: unknown): string {
  if (error instanceof ApiError) {
    return MESSAGES[error.code] ?? error.message;
  }

  return 'Une erreur inattendue est survenue. Réessayez dans un instant.';
}
